// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3HUkd","unreadBadge":"styles_unreadBadge__2NEb_","modalContent":"styles_modalContent__2XowS","modal":"styles_modal__1aFkG"};